export default __webpack_public_path__ + "static/ccr-nelson-logo-19717d9a16cb5229254e894be8c6337a.png";